import styled from 'styled-components';

import { COLORS } from '../../../tokens/colors';
import { getSizes, radioSizes, TControlDirection, TControlSize } from '../baseControlsData';

const getRadioSizes = (size: TControlSize) => getSizes(size, radioSizes);

type IStyleProps = {
    size: TControlSize,
    disabled: boolean,
    withLabel: boolean,
    direction: TControlDirection,
}

export const Label = styled.label<IStyleProps>`
    display: flex;
    flex-direction: ${({ direction }) => direction === 'right' ? 'row-reverse' : 'row'};
    flex-wrap: nowrap;
    align-items: center;
    margin: 0;
    padding: 0;
    ${p => getRadioSizes(p.size).font};
    color: ${({ disabled }) => disabled ? COLORS.TextDisabled : COLORS.TextPrimary};
    user-select: none;

    input[type="radio"] {
        position: relative;
        appearance: none;
        flex: 0 0 auto;
        width: ${p => getRadioSizes(p.size).inputSize}px;
        height: ${p => getRadioSizes(p.size).inputSize}px;
        margin: 0;
        margin-right: ${p => p.withLabel && p.direction !== 'right' ? getRadioSizes(p.size).rMargin + 'px' : 0 };
        margin-left: ${p => p.withLabel && p.direction === 'right' ? getRadioSizes(p.size).rMargin + 'px' : 0 };
        padding: 0;
        background-color: ${COLORS.BgMain};
        border-width: 2px;
        border-style: solid;
        border-color: ${COLORS.Brand_Blue};
        border-radius: 50%;
        transition: .3s;
        outline: none;
        box-sizing: border-box;
        cursor: pointer;
        align-self: flex-start;

        @media (hover: hover) {
            &:hover {
                border-color: ${COLORS.Link};
            }
        }

        &:required:invalid {
            border-color: ${COLORS.Error};
            background-color: ${COLORS.BgError};

            &:hover {
                border-color: ${COLORS.Link};
                background-color: ${COLORS.BgMain};
            }
        }

        &:disabled {
            border-color: ${COLORS.GRAY_LIGHT};
            background-color: ${COLORS.GRAY_LIGHT};
            cursor: default;
            pointer-events: none;

            @media (hover: hover) {
                &:hover {
                    border-color: ${COLORS.GRAY_LIGHT};
                }
            }
        }

        &:checked {
            border-color: ${COLORS.Control};
            background-color: ${COLORS.Control};

            &:after {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                transform-origin: center;
                width: ${p => getRadioSizes(p.size).radioCheckSize}px;
                height: ${p => getRadioSizes(p.size).radioCheckSize}px;
                border-radius: 50%;
                background-color: ${COLORS.BgMain};
            }

            @media (hover: hover) {
                &:hover {
                    border-color: ${COLORS.Link};
                    background-color: ${COLORS.Outline_Dark};
                }
            }

            &:disabled {
                border-color: ${COLORS.GRAY_DARK};
                background-color: ${COLORS.GRAY_DARK};
                pointer-events: none;

                &:after {
                    background-color: ${COLORS.GRAY_LIGHT};
                }
            }
        }
    }
`;
